import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AppConfigService } from './core/services/app-config/app-config.service';
import { AppConfig } from './assets/config/app-config';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from './core/services/msal/msal.service';
import { APP_CONFIG_TOKEN } from './core/services/app-config/app-config';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import { ApplicationConfig } from '@angular/core';
import { CompanyIdInterceptor } from './core/services/company/company-service.interceptor';

const appConfigService: AppConfigService<AppConfig> =
  new AppConfigService<AppConfig>();
appConfigService.load().then((response) => {
  const config: AppConfig = appConfigService.settings ?? ({} as AppConfig);

  const msalCOnfigProviders: ApplicationConfig = {
    providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: CompanyIdInterceptor,
        multi: true,
      },
      {
        //Use injection token to make config available throughout application
        provide: APP_CONFIG_TOKEN,
        useValue: config,
      },
      {
        provide: MSAL_INSTANCE,
        useFactory: () => MSALInstanceFactory(config),
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory,
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: () => MSALInterceptorConfigFactory(config),
      },
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      provideHttpClient(withInterceptorsFromDi()),
    ],
  };
  //join the two providers
  const appConfigProviders = appConfig.providers.concat(
    msalCOnfigProviders.providers
  );

  bootstrapApplication(AppComponent, {
    providers: appConfigProviders,
  }).catch((err) => console.error(err));
});
